import { StartPageHeader } from "./StartPageHeader/StartPageHeader";
import { StartPageMain } from "./StartPageMain/StartPageMain";
export function StartPageComponents(){
    return (
        <>
            <StartPageHeader></StartPageHeader>
            <StartPageMain></StartPageMain>
        </>
       

    );
}